module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Airplay-afdd62be52cc6c1416e1c47b827372a4.svg";